import React, { useState } from 'react';
import HeaderComponent from '../../LandingPage/Components/Header';
import styles from '../style.module.scss';

import slides from '../slides.js';
import OnboardingContentComponent from './OnboardingContent';
import { useHistory } from 'react-router-dom';

const OnboardingComponent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();
  const onNextClick = () => {
    if (currentPage === 4) {
      history.push('/signin');
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  const onSkip = () => {
    history.push('/signin');
  };

  return (
    <div className="pb-1">
      <HeaderComponent />
      <OnboardingContentComponent
        onNextClick={onNextClick}
        onSkip={onSkip}
        currentPage={currentPage}
        item={slides.find((slide) => slide.id === currentPage) || {}}
      />
    </div>
  );
};
export default OnboardingComponent;
